function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useCallback, useMemo, useContext, useState } from "react";
import { useLayoutEffect } from "../../hooks/useLayoutEffect";
import { isObject } from "../../utils/is";
import useForceUpdate from "../../hooks/useForceUpdate";
import usePrevious from "../../hooks/usePrevious";
import createNamedContext from "../../utils/createNamedContext";
var noop = function() {
    return undefined;
};
export var createDescendantContext = function(name) {
    return createNamedContext(name, {
        descendants: [],
        register: noop,
        unregister: noop
    });
};
export var useDescendantInit = function() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return useState(initialValue);
};
export var useDescendants = function(Ctx) {
    return useContext(Ctx).descendants;
};
var DescendantProvider = function(param1) {
    var Ctx = param1.context, descendants = param1.descendants, setDescendants = param1.setDescendants, children = param1.children;
    var register = useCallback(function(_param) {
        var element = _param.element, rest = _objectWithoutProperties(_param, [
            "element"
        ]);
        if (!element) return;
        setDescendants(function(descendantsState) {
            var nextDescendantsState;
            if (descendantsState.length === 0) {
                nextDescendantsState = [
                    _objectSpread({}, rest, {
                        element: element,
                        index: 0
                    })
                ];
            } else if (descendantsState.find(function(o) {
                return o.element === element;
            })) {
                nextDescendantsState = descendantsState;
            } else {
                var DOMIndex = descendantsState.findIndex(function(o) {
                    if (!o.element || !element) return false;
                    return Boolean(o.element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING);
                });
                var nextDescendant = _objectSpread({}, rest, {
                    element: element,
                    index: DOMIndex
                });
                if (DOMIndex === -1) {
                    nextDescendantsState = _toConsumableArray(descendantsState).concat([
                        nextDescendant
                    ]);
                } else {
                    nextDescendantsState = _toConsumableArray(descendantsState.slice(0, DOMIndex)).concat([
                        nextDescendant
                    ], _toConsumableArray(descendantsState.slice(DOMIndex)));
                }
            }
            return nextDescendantsState.map(function(d, nextIndex) {
                return _objectSpread({}, d, {
                    index: nextIndex
                });
            });
        });
    }, []);
    var unregister = useCallback(function(element) {
        if (!element) return;
        setDescendants(function(descendantsState) {
            return descendantsState.filter(function(param) {
                var e = param.element;
                return e !== element;
            });
        });
    }, []);
    var value = useMemo(function() {
        return {
            descendants: descendants,
            register: register,
            unregister: unregister
        };
    }, [
        descendants,
        register,
        unregister
    ]);
    return _jsx(Ctx.Provider, {
        value: value,
        children: children
    });
};
export { DescendantProvider };
export var useDescendant = function(descendant, context) {
    var ref1 = useContext(context), register = ref1.register, unregister = ref1.unregister, descendants = ref1.descendants;
    var forceUpdate = useForceUpdate();
    var index = descendants.findIndex(function(d) {
        return d.element === descendant.element;
    });
    var previousDescendants = usePrevious(descendants);
    var someDescendantsHaveChanged = descendants.some(function(_, idx) {
        var ref;
        return descendant.element !== (previousDescendants === null || previousDescendants === void 0 ? void 0 : (ref = previousDescendants[idx]) === null || ref === void 0 ? void 0 : ref.element);
    });
    var previousDescendant = usePrevious(descendant);
    var descendantDataDidChange = isObject(descendant.data) && Object.keys(descendant.data).some(function(key) {
        return (previousDescendant === null || previousDescendant === void 0 ? void 0 : previousDescendant.data[key]) !== descendant.data[key];
    });
    useLayoutEffect(function() {
        if (descendant.disabled) return;
        if (!descendant.element) {
            forceUpdate();
            return;
        }
        register(_objectSpread({}, descendant, {
            index: index
        }));
        return function() {
            return unregister(descendant === null || descendant === void 0 ? void 0 : descendant.element);
        };
    }, [
        forceUpdate,
        index,
        register,
        unregister,
        someDescendantsHaveChanged,
        descendant.value,
        descendant.element,
        descendant.index,
        descendant.disabled,
        descendantDataDidChange
    ]);
    return index;
};
